import React, { memo, forwardRef } from "react";
const SvgEquilibriumwithoverandunderscript = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect width={8} height={9} x={12} y={2} fill="#DBDBDB" rx={1} />
      <rect width={8} height={9} x={12} y={21} fill="#DBDBDB" rx={1} />
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M22.707 8.293a1 1 0 10-1.414 1.414L24.586 13H5a1 1 0 100 2h22a1 1 0 00.707-1.707l-5-5zM9.293 23.707a1 1 0 001.414-1.414L7.414 19H27a1 1 0 100-2H5a1 1 0 00-.707 1.707l5 5z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgEquilibriumwithoverandunderscript.displayName =
  "SvgEquilibriumwithoverandunderscript";
const MemoForwardRef = memo(SvgEquilibriumwithoverandunderscript);
export default MemoForwardRef;
